import { forwardRef } from 'react';

import { Turnstile } from '@marsidev/react-turnstile';
import { AlertCircleIcon } from 'lucide-react';
import { proxy, useSnapshot } from 'valtio';

import { useMediaQuery } from '../hooks/use-media-query.jsx';
import { cn } from '../utils/cn.js';
import { CLOUDFLARE_TURNSTILE_SITE_KEY } from '../utils/constants.js';

export const turnstileStatusStateStatuses = {
  LOADING: 'loading',
  PENDING: 'pending',
  UNSUPPORTED: 'unsupported',
  ERROR: 'error',
  SOLVED: 'solved',
};

export const turnstileStatusState = proxy({
  status: 'loading',
  setStatus: (newStatus) => (turnstileStatusState.status = newStatus),
});

export const TurnstileWidget = forwardRef((props, ref) => {
  const { status, setStatus } = useSnapshot(turnstileStatusState);
  const isExtraSmall = useMediaQuery('(max-width: 365px)');

  return status === turnstileStatusStateStatuses.UNSUPPORTED ? (
    <div className="flex flex-row items-start gap-2 rounded-md bg-destructive px-4 py-2 text-destructive-foreground">
      <AlertCircleIcon className="size-6" />
      <div>
        <p className="pb-1 font-semibold">
          O seu browser não suporta o Cloudflare Turnstile
        </p>
        <p className="text-sm">
          Por favor utilize um browser recente para conseguirmos detetar se é ou
          não é um robô
        </p>
      </div>
    </div>
  ) : (
    <>
      <div
        className={cn(
          'flex h-[65px] w-full flex-row items-center justify-center border border-[#e0e0e0] bg-[#fafafa]',
          status !== turnstileStatusStateStatuses.LOADING && 'hidden',
        )}
      >
        <div
          className="text-surface inline-block size-7 animate-spin rounded-full border-[3px] border-solid border-current border-e-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white"
          role="status"
        />
      </div>

      <div
        className={cn(
          status !== turnstileStatusStateStatuses.LOADING ? 'block' : 'hidden',
        )}
      >
        <Turnstile
          {...props}
          ref={ref}
          siteKey={CLOUDFLARE_TURNSTILE_SITE_KEY}
          options={{
            retry: 'auto',
            theme: 'light',
            size: isExtraSmall ? 'compact' : 'flexible',
          }}
          onError={() => setStatus(turnstileStatusStateStatuses.ERROR)}
          onWidgetLoad={() => {
            setStatus(turnstileStatusStateStatuses.PENDING);
          }}
          onUnsupported={() =>
            setStatus(turnstileStatusStateStatuses.UNSUPPORTED)
          }
          // onTimeout={() => setStatus('timed-out)}
          onSuccess={(token) => {
            setStatus(turnstileStatusStateStatuses.SOLVED);
          }}
        />
      </div>
    </>
  );
});
